import project1 from "../../images/gallery/desktop/project1.jpg";
import project2 from "../../images/gallery/desktop/project2.jpg";
import project3 from "../../images/gallery/desktop/project3.jpg";
import project4 from "../../images/gallery/desktop/project4.jpg";
import project5 from "../../images/gallery/desktop/project5.jpg";
import project6 from "../../images/gallery/desktop/project6.jpg";
import project7 from "../../images/gallery/desktop/project7.jpg";
import project8 from "../../images/gallery/desktop/project8.jpg";
import project9 from "../../images/gallery/desktop/project9.jpg";
import project10 from "../../images/gallery/desktop/project10.jpg";

const projectImages = [
  {
    src: project1,
    width: 1600,
    height: 2400,
  },
  {
    src: project2,
    width: 2400,
    height: 1800,
  },
  {
    src: project3,
    width: 2400,
    height: 1800,
  },
  {
    src: project4,
    width: 1600,
    height: 2400,
  },
  {
    src: project5,
    width: 2400,
    height: 1800,
  },
  {
    src: project6,
    width: 2400,
    height: 1800,
  },
  {
    src: project7,
    width: 1800,
    height: 2400,
  },
  {
    src: project8,
    width: 1600,
    height: 2400,
  },
  {
    src: project9,
    width: 2400,
    height: 1800,
  },
  {
    src: project10,
    width: 1800,
    height: 2400,
  },
];

export default projectImages;
